import React, { Fragment } from 'react';
import {
    Segment,
    Form,
    Select,
    Search,
    Input,
    TextArea,
    Button,
    Table,
    Divider,
    Popup,
    Icon,
    Header
} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FiltersOnStyle, IconHeader, RightHeaderWithButton } from '../../Professor/ProfessorInputGrades/css';
import ThreeColumnTableRow from '../../Admin/CreateCourse/ThreeColumnTableRow';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const detailsText = {
    fontWeight: 'normal'
};

// props: institutionTypes LKP, educationLevels LKP,
// onInstitutionTypeChange fn

const DONE_TYPING_INTERVAL = 1000;


const resultRenderer = ({ name, place }) => (
    <div>
        <span>{name} {' | '}{place.name} {' | '} {!!place.country && place.country.name}</span>
    </div>
);
export default class PreviousEducations extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {

            addMode: false,

            institutions: [],
            loading: false,
            institutionType: null,
            institution: '',
            institutionName: '',

            educationLevel: null,
            educationLevels: [],
            licenceNumber: '',
            graduationYear: '',
            averageGrade: null,
            comment: '',
            selectedInstitution: null,
            // edit details
            newLicenceNumber: null,
            newEducationLevel: null,
            newAverageGrade: null,
            newComment: null,

            editMode: false,
            institutionId: '',

            institutionTypeErr: false,
            licenceNumberErr: false,
            educationLevelErr: false,
            institutionErr: false,
            showDetails: false,
            index_: null
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onInstitutionTypeChange = this.onInstitutionTypeChange.bind(this);

        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleResultSelect = this.handleResultSelect.bind(this);
        this.onAddOrEditPreviousEducation = this.onAddOrEditPreviousEducation.bind(this);
        this.onChange = this.onChange.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.openData = this.openData.bind(this);
        this.resetForm = this.resetForm.bind(this);

        this.typingTimer = null;
    }

    onInstitutionTypeChange(event, { value }) {
        this.setState({ institutionType: value });
    }

    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    handleInputChange(event, { name, value }) {
        this.setState({ [name]: value });
    }

    handleResultSelect(e, { result }) {
        this.setState({ institution: result.name, selectedInstitution: result });
    }
    submitHandler(e) {
        e.preventDefault();
    }

    openData(id) {
        const { previousEducations } = this.props;
        let prevEducation = previousEducations.filter(el => el.id === id)[0];
        const obj = { type: prevEducation.institution.type.id, name: prevEducation.institution.name };

        axios.post('/institutions/filter/', { ...obj })
            .then(res => this.setState({ institutions: res.data }))
            .catch(err => console.log('Error '));

        axios.get('education-levels')
            .then(res => {
                this.setState({ educationLevels: res.data });
            })
            .catch(console.log('Error get education levels'));

        this.setState({
            editMode: true,

            institutionType: prevEducation.institution.type.id,
            institution: prevEducation.institution.name,
            institutionId: prevEducation.institution.id,

            educationLevel: prevEducation.educationLevel.id,
            licenceNumber: prevEducation.licenceNumber,
            averageGrade: prevEducation.averageGrade,
            comment: prevEducation.comment,
        });
    }

    handleSearchChange(e, { value }) {
        clearTimeout(this.typingTimer);
        this.setState({ loading: true, institution: value });
        this.typingTimer = setTimeout(() => {
            if (value && value.length >= 4) {
                const obj = { type: this.state.institutionType, name: value };

                axios.post('/institutions/filter/', { ...obj })
                    .then(res => this.setState({ loading: false, institutions: res.data }))
                    .catch(err => this.setState({ loading: false }));
            }
        }, DONE_TYPING_INTERVAL);
    }

    resetForm() {
        this.setState({
            editMode: false,
            institutionType: '',
            institution: '',
            educationLevel: '',
            licenceNumber: '',
            averageGrade: '',
            comment: '',
            addMode: false
        });
    }

    clearInputs() {
        this.setState({
            editMode: false,
            institutions: [],
            loading: false,
            institutionType: null,
            institution: '',
            institutionName: '',

            educationLevel: null,
            licenceNumber: '',
            graduationYear: '',
            averageGrade: null,
            comment: '',
            selectedInstitution: null,

            // edit details
            newLicenceNumber: null,
            newEducationLevel: null,
            newAverageGrade: null,
            newComment: null,

            institutionTypeErr: false,
            licenceNumberErr: false,
            educationLevelErr: false,
            institutionErr: false,
        });
    }
    onAddOrEditPreviousEducation() {
        const {
            selectedInstitution, licenceNumber, educationLevel, graduationYear, institution, institutionType, edit
        } = this.state;
        if (!edit && (!institutionType || !licenceNumber || !educationLevel || !institution)) {
            if (!institutionType) { this.setState({ institutionTypeErr: true }); } else { this.setState({ institutionTypeErr: false }); }
            if (!licenceNumber) { this.setState({ licenceNumberErr: true }); } else { this.setState({ licenceNumberErr: false }); }
            if (!educationLevel) { this.setState({ educationLevelErr: true }); } else { this.setState({ educationLevelErr: false }); }
            if (!institution) { this.setState({ institutionErr: true }); } else { this.setState({ institutionErr: false }); }

            toast('Niste unijeli sva obavezna polja.');
        } else {
            let prevEducation = {};
            if (edit) {
                prevEducation = {
                    ...this.state.idOptLockPrevEducation,
                    averageGrade: this.state.averageGrade === '' ? this.state.averageGrade : parseFloat(this.state.newAverageGrade),
                    licenceNumber: this.state.newLicenceNumber,
                    educationLevel: { id: this.state.newEducationLevel },
                    comment: this.state.newComment,
                    graduationYear,
                };
                // if (this.state.newAverageGrade !== null)prevEducation = { ...prevEducation, averageGrade: this.state.newAverageGrade };
                // if (this.state.newLicenceNumber !== null)prevEducation = { ...prevEducation, licenceNumber: this.state.newLicenceNumber };
                // if (this.state.newEducationLevel !== null)prevEducation = { ...prevEducation, educationLevel: this.state.newEducationLevel };
                // if (this.state.newComment !== null)prevEducation = { ...prevEducation, comment: this.state.newComment };
            } else {
                prevEducation = {
                    institution: { id: selectedInstitution.id },
                    // eslint-disable-next-line radix
                    averageGrade: parseFloat(this.state.averageGrade),
                    licenceNumber: this.state.licenceNumber,
                    educationLevel: { id: this.state.educationLevel },
                    comment: this.state.comment,
                    graduationYear,
                };
            }

            if (localStorage.getItem('activeRole').substr(0, 8) === 'HR admin') {
                if (JSON.parse(localStorage.getItem('person')))prevEducation = { ...prevEducation, person: { id: JSON.parse(localStorage.getItem('person')).id } };
                else prevEducation = { ...prevEducation, institution: selectedInstitution, educationLevel: this.state.educationLevel };
            } else {
                prevEducation = { ...prevEducation, person: { id: JSON.parse(localStorage.getItem('student')).studentId } };
            }


            this.setState({ institutionId: '' });
            // this.clearInputs();
            if (edit) {
                this.setState({ showDetails: false, edit: false });
                this.props.onEditPreviousEducation(prevEducation);
            } else {
                this.resetForm();
                this.props.onAddNewPreviousEducation(prevEducation);
            }
        }
    }


    render() {
        return (
            <React.Fragment>

                {/* eslint-disable-next-line react/jsx-no-undef */}
                {this.state.showDetails && <Fragment>

                    <Table celled unstackable compact size="small">
                        <Table.Header>
                            <Table.Row>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <ThreeColumnTableRow
                                twoCol
                                name={(this.props.previousEducations[this.state.index_].institution && this.props.previousEducations[this.state.index_].institution.type) ? this.props.previousEducations[this.state.index_].institution.type.name.substring(0, 1).toUpperCase() + this.props.previousEducations[this.state.index_].institution.type.name.substring(1) : ''}
                                keyName="institution"
                                value={this.props.previousEducations[this.state.index_].institution ? this.props.previousEducations[this.state.index_].institution.name + ' | ' + this.props.previousEducations[this.state.index_].institution.place.name : ''}
                                disabled
                                educationLevels={this.props.educationLevels}
                                defValue={this.props.previousEducations[this.state.index_].institution.name + ' | ' + this.props.previousEducations[this.state.index_].institution.place.name}
                                // defValue={this.props.previousEducations[this.state.index_].institution.name + ' | ' + this.props.previousEducations[this.state.index_].institution.place.name + ' | ' + !!this.props.previousEducations[this.state.index_].institution.place.country && this.props.previousEducations[this.state.index_].institution.place.country.name}

                            />
                            <ThreeColumnTableRow
                                name="Nivo obrazovanja"
                                keyName="newEducationLevel"
                                value={this.props.previousEducations[this.state.index_].educationLevel ? this.props.previousEducations[this.state.index_].educationLevel.name : ''}
                                onChange={this.handleInputChange}
                                edit
                                input={this.state.newEducationLevel ? this.state.newEducationLevel : null}
                                educationLevels={this.props.educationLevels}
                                defValue={this.props.previousEducations[this.state.index_].educationLevel ? this.props.previousEducations[this.state.index_].educationLevel.name : ''}
                            />
                            <ThreeColumnTableRow
                                name="Broj diplome"
                                keyName="newLicenceNumber"
                                value={this.props.previousEducations[this.state.index_] ? this.props.previousEducations[this.state.index_].licenceNumber : ''}
                                input={this.state.newLicenceNumber ? this.state.newLicenceNumber : null}
                                onChange={this.onChange}
                                edit
                                defValue={this.props.previousEducations[this.state.index_] ? this.props.previousEducations[this.state.index_].licenceNumber : ''}
                            />
                            <ThreeColumnTableRow
                                name="Prosjek"
                                keyName="newAverageGrade"
                                value={this.props.previousEducations[this.state.index_] ? this.props.previousEducations[this.state.index_].averageGrade : ''}
                                onChange={this.onChange}
                                edit
                                defValue={this.props.previousEducations[this.state.index_] ? this.props.previousEducations[this.state.index_].averageGrade : ''}
                            />
                            <ThreeColumnTableRow
                                name="Napomena"
                                keyName="newComment"
                                value={this.props.previousEducations[this.state.index_] ? this.props.previousEducations[this.state.index_].comment : ''}
                                onChange={this.onChange}
                                edit
                                defValue={this.props.previousEducations[this.state.index_] ? this.props.previousEducations[this.state.index_].comment : ''}
                            />
                        </Table.Body>
                        <Table.Row>
                            <Table.Cell
                                colSpan={3}
                                textAlign="right"
                                verticalAlign="middle"
                            >

                                <Button
                                    compact
                                    floated="right"
                                    basic="true"
                                    color="blue"
                                    onClick={() => { this.setState({ showDetails: false, edit: false }); }}
                                >Odustani
                                </Button>
                                <Button
                                    compact
                                    floated="right"
                                    primary
                                    color="blue"
                                    onClick={() => { this.onAddOrEditPreviousEducation(); }}
                                >Spremi
                                </Button>
                            </Table.Cell>
                        </Table.Row>

                    </Table>

                </Fragment>}
                {!!this.props.previousEducations.length &&
                <div className={!this.props.noSegment && 'ui clearing segment'}>
                    <br />
                    <Table compact size="small">
                        <Table.Body>
                            {this.props.previousEducations.map((el, i) =>
                                (<Table.Row key={el.i}>
                                    <Table.Cell verticalAlign="middle">
                                        {el.institution.name} {' | '}{el.institution.place.name} {' | '} {!!el.institution.place.country && el.institution.place.country.name}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle">

                                        <Popup
                                            content="Izmjena / Detalji"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={this.state.edit}
                                                    compact
                                                    basic="true"
                                                    circular
                                                    icon="pencil"
                                                    size="small"
                                                    color="green"
                                                    onClick={() => this.setState({
                                                        showDetails: true, index_: i, edit: true, idOptLockPrevEducation: { id: el.id, optLock: el.optLock }
                                                    })}
                                                />}
                                        />
                                        <Popup
                                            content="Brisanje"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={this.state.edit}
                                                    compact
                                                    basic="true"
                                                    circular
                                                    icon="trash alternate"
                                                    size="small"
                                                    color="red"
                                                    onClick={() => this.props.onDeletePreviousEducation(el.id)}
                                                />}
                                        />
                                    </Table.Cell>

                                </Table.Row>))}
                        </Table.Body>
                    </Table>
                </div>
                }

                {this.props.noSegment && <br />}

                {/* {!this.state.addMode && */}
                {/* <Button */}
                {/*    basic */}
                {/*    color="blue" */}
                {/*    onClick={() => { this.setState({ addMode: true }); }} */}
                {/* >Dodaj obrazovanje */}
                {/* </Button>} */}


                <div className={!this.props.noSegment && 'ui clearing segment'}>
                    <Form onSubmit={this.submitHandler} noValidate>
                        <Form.Field
                            required
                            disabled={this.props.disabled}
                            control={Select}
                            clearable
                            value={this.state.institutionType}
                            options={this.props.institutionTypes}
                            placeholder="Tip institucije"
                            onChange={this.handleInputChange}
                            name="institutionType"
                            label="Tip institucije"
                            error={this.state.institutionTypeErr}
                        />
                        <Form.Field
                            required
                            disabled={this.props.disabled}
                            control={Search}
                            fluid
                            loading={this.state.loading}
                            onResultSelect={this.handleResultSelect}
                            onSearchChange={this.handleSearchChange}
                            results={this.state.institutions}
                            value={this.state.institution}
                            resultRenderer={resultRenderer}
                            placeholder="Naziv insitucije"
                            label="Naziv institucije"
                            noResultsMessage="Nema rezultata."
                            minCharacters={4}
                            error={this.state.institutionErr}
                        />

                        <Form.Field
                            required
                            disabled={this.props.disabled}
                            control={Select}
                            clearable
                            value={this.state.educationLevel}
                            options={this.props.educationLevels}
                            placeholder="Nivo obrazovanja"
                            onChange={this.handleInputChange}
                            name="educationLevel"
                            label="Nivo obrazovanja"
                            error={this.state.educationLevelErr}
                        />
                        <Form.Field
                            required
                            disabled={this.props.disabled}
                            control={Input}
                            value={this.state.licenceNumber}
                            label="Broj diplome"
                            onChange={this.handleInputChange}
                            name="licenceNumber"
                            error={this.state.licenceNumberErr}
                        />
                        <Form.Field
                            disabled={this.props.disabled}
                            type="number"
                            control={Input}
                            value={this.state.averageGrade}
                            label="Prosjek"
                            onChange={this.handleInputChange}
                            name="averageGrade"
                        />
                        <Form.Field
                            disabled={this.props.disabled}
                            control={TextArea}
                            value={this.state.comment}
                            label="Opis"
                            onChange={this.handleInputChange}
                            name="comment"
                        />
                        <Button
                            color="blue"
                            basic="true"
                            floated="right"
                            onClick={this.resetForm}
                        >Poništi</Button>
                        <Button disabled={this.props.disabled} primary floated="right" onClick={this.onAddOrEditPreviousEducation}>Dodaj</Button>

                    </Form>

                </div>

                {/* <ToastContainer hideProgressBar /> */}

            </React.Fragment>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentCreateAndEdit/PreviousEducations.js